import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProductService } from 'src/app/services/product.service';
import * as _ from "lodash";
import { LoaderService } from 'src/app/shared/services/loader.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ExcelService } from 'src/app/services/excel.service';
import moment from 'moment';
import swal from 'sweetalert2'
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
    selector: 'app-manage-sub-Categ',
    templateUrl: './manage-sub-Categ.component.html',
    styleUrls: ['./manage-sub-Categ.component.scss']
})
export class ManageSubCategComponent implements OnInit {
    filterValue: string = ''
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
        "productCategoryTypeName",
        "subCategoryName",
        "action"
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
    dataExcel: any = [];
    excelColumns: string[];
    constructor(private productService: ProductService,
        private loaderService: LoaderService,
        private toastr: NotificationService,
        private excelService: ExcelService,
        private navigationService: NavigationService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.getTableData()
    }

    getTableData() {
        this.productService.getAllProductSubCategory().subscribe((result) => {
            this.data = [];
            this.dataExcel = [];
            this.data = result;
            this.dataExcel = result;
            this.data = _.orderBy(this.data, ["priority"]);
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.filterValue = filterValue;
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    clearFilter() {
        const inputElement = document.getElementById('filter-input') as HTMLInputElement;
        if (inputElement) {
            inputElement.value = '';
        }
        this.dataSource.filter = '';
        this.searchInput.nativeElement.value = "";
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
        this.dataSource.sort.active = '';
        this.dataSource.sort.direction = '';
        this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
        this.getTableData();
    }

    gotoProductSub(id) {
        this.navigationService.gotoProductSubId(id);
    }

    exportAsXLSX(): void {
        this.loaderService.start();
        setTimeout(() => {
            var exportData = this.dataExcel;
            if (!exportData || exportData.length === 0) {
                this.toastr.showInfo("No data available to export");
                this.loaderService.hide();
                return;
            }
            const excelList = [];
            this.excelColumns = [
                "S.No",
                "Product Category",
                'Product Sub Category'
            ];
            exportData.forEach((a, index) => {
                excelList.push({
                    sno: ++index,
                    "productCategoryTypeName": a.productCategoryTypeName,
                    "subCategoryName": a.subCategoryName
                });
            });
            this.excelService.exportAsExcelFile(excelList, "ProductSubCategory_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
            this.loaderService.stop();
        }, 500);
    }

    deleteUser(user) {
        const txt = 'You want to delete ' + user?.subCategoryName + '?';
        const Yes = 'Yes';
        const No = 'No';
        swal.fire({
            text: txt,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#7D32DE',
            cancelButtonColor: '#23C00A',
            confirmButtonText: Yes,
            cancelButtonText: No,
        }).then((result) => {
            if (result.value) {
                this.productService.deleteProductSubCategory(user.id).subscribe((result) => {
                        this.toastr.showSuccess("Deleted Successfully");
                        this.getTableData();
                
                });
            }
        });
    }
}
